export default __webpack_public_path__ + "static/media/SubImage3.f0033e29.JPG";